<procure-filter-button
  label="Suppliers"
  infiniteScroll
  [control]="control()"
  [items]="items()"
  [isLoading]="isLoading()"
  (fetchMore)="fetch($event)"
/>
